/* SUMMARY

    0 - ANIMATION

*/

export default function animation(){
    /*--------------/ 0 - ANIMATION /-------------------*/
    // Scroll animation
    window.onscroll = () => {
        const target = document.querySelectorAll("[data-animate]");
        target.forEach(function (element) {
            const animateClass = 'animation'
            const windowTop = element.getBoundingClientRect().top
            const windowCall = window.screen.height * 0.90
            if (windowTop < windowCall) {
                element.classList.add(animateClass);
            }
        });
    }

    // Initial Animation
    $(document).ready(function() {
        console.log;("hello")
        const target = document.querySelectorAll("[data-animate]");
        target.forEach(function (element) {
            const animateClass = 'animation'
            const windowTop = element.getBoundingClientRect().top
            const windowCall = window.screen.height * 0.90
            if (windowTop < windowCall) {
                element.classList.add(animateClass);
            }
        });
    })

}